// SELECTORS FNS
import {hotelName as hotelNameSelector} from '@stencil/hotels-details-reducer/src/selectors';
import React from 'react';
// HOOKS
import {useSelector} from 'react-redux';
import styled from 'styled-components';

import {SectionHeader} from '../../../../../stories/components/CommonStyleUtils/dwebCommon.styles';

const HotelNameText = styled(SectionHeader)(
  props => `
  padding:${props.theme.spacing.base} 0;
`,
);

function HotelName() {
  const hotelName = useSelector(hotelNameSelector);
  return <HotelNameText itemProp="name">{hotelName}</HotelNameText>;
}

export default HotelName;
